import Vue from 'vue'

const state = {
  now: Math.floor(Date.now() / 1000),
  nowMoment: null,
  started: false,
};

const getters = {}

const actions = {
  start({ commit }) {
    // Don't start multiple intervals
    if (state.started) {
      return
    }
    state.started = setInterval(() => {
      commit("tick");
    }, 1000);
  }
};

const mutations = {
  tick(state) {
    state.now = Math.floor(Date.now() / 1000);
    state.nowMoment = Vue.moment.unix(state.now)
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}